(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["line-item-compact"] && !Shopify.designMode) return;
  try {
    const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => arr.push(document.querySelector(selector)));
    return arr;
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rb-height-choice"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const config = document.getElementById('rb-height-choice-config');
    const root = document.getElementById('buy');
    const box = root?.querySelector('#rb-hsel');
    const form = root?.querySelector('[data-rb-atc]');
    if (!config || !box || !form || box.dataset.rbHeightReady) return;
    box.dataset.rbHeightReady = 'true';
    box.classList.add('rb-height-preview');
    const mobile = matchMedia('(max-width: 768px)');
    const sub = box.querySelector('.rb-hsel-sub');
    const originalSub = sub.textContent;
    const summary = box.querySelector('.rb-height-menu > summary');
    const originalLabel = summary.getAttribute('aria-label');
    const roofButtons = [box.querySelector('#rb-hsel-flad'), box.querySelector('#rb-hsel-skraa')];
    let roofChosen = true; /* Fladt loft er prævalgt — kunden skal kun vælge højden */
    let heightChosen = false;
    const help = document.getElementById('rb-height-help-template').content.firstElementChild.cloneNode(true);
    help.querySelector('.rb-height-help-description').textContent = originalSub;
    help.querySelector('.rb-height-help-service').textContent = box.querySelector('.rb-hsel-service')?.textContent || '';
    box.append(help);
    const error = document.getElementById('rb-height-error-template').content.firstElementChild.cloneNode(true);
    box.append(error);
    function update() {
      sub.textContent = mobile.matches ? config.dataset.measure : originalSub;
      summary.dataset.rbUnconfirmed = String(mobile.matches && !heightChosen);
      summary.dataset.rbPlaceholder = config.dataset.height;
      summary.setAttribute('aria-label', mobile.matches && !heightChosen ? config.dataset.height : originalLabel);
      roofButtons.forEach(button => {
        button.classList.toggle('rb-height-unconfirmed', mobile.matches && !roofChosen);
        button.setAttribute('aria-pressed', String((!mobile.matches || roofChosen) && button.classList.contains('on')));
      });
      if (!mobile.matches || (roofChosen && heightChosen)) error.hidden = true;
    }
    box.addEventListener('click', event => {
      if (event.target.closest('#rb-hsel-flad,#rb-hsel-skraa')) roofChosen = true;
      if (event.target.closest('button[data-height]')) heightChosen = true;
      requestAnimationFrame(update);
    }, true);
    box.addEventListener('change', event => {
      if (event.target.id === 'rb-hsel-select') heightChosen = true;
      requestAnimationFrame(update);
    });
    form.addEventListener('submit', event => {
      if (!mobile.matches || (roofChosen && heightChosen)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = false;
      box.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      (roofChosen ? summary : roofButtons[0]).focus({preventScroll: true});
    }, true);
    mobile.addEventListener('change', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
